import { store } from 'api/store';

const useTimezone = () => {
  const timezones = store.getState().timezones;

  // Uses the timezone name to get the corresponsing object.
  const getSelectedTimezone = (tn) => timezones.find((tz) => tz.name === tn);
  const getTimezoneGMT = (tz) => timezones.find((t) => t.timezone === tz)?.name;

  return { timezones, getSelectedTimezone, getTimezoneGMT };
};

export default useTimezone;
